import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SectionLoading from "../common/SectionLoading";
import SectionLoadingError from "../common/SectionLoadingError";
import Spinner from "../common/spinner";
import SelectPatient from "../common/SelectPatient";
import EVisitGetStarted from "./EVisitGetStarted";
import EVisitInEligible from "./EVisitInEligible";
import * as d from "../../reducers/domainReducer";
import { getFirstName } from "../../helpers/formatting";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import * as types from "../../constants/actionTypes";
import NoProxy from '../common/NoProxy';
import { Redirect } from 'react-router-dom';

class EVisit_ProxySelector extends React.Component {
    constructor(props) {
        super(props);
        this.unexpectedErrorMessage = "Sorry, we are not able to load your eVisit. Please schedule an appointment using other options available on MyBSWHealth.";
        this.shouldLoadEVistPage = this.shouldLoadEVistPage.bind(this);
        this.ourCallback = this.ourCallback.bind(this);
        this.state = { activeUserIndex: 0, userSelected: null };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.EVisit.ProxySelector.ComponentDidMount", new Date(), Tools.getURLPath());
        const { primaryUser, hasMychart, proxyListLoaded, myProxies, isCovidScreeningModalForProxy } = this.props;
        if (!hasMychart || proxyListLoaded && ((myProxies.length < 2 && primaryUser.isMinor) || isCovidScreeningModalForProxy)) {
            this.props.history.replace("/evisitnow");
        }
        this.savePreference = this.props.history.block(targetLocation => {
            if (this.state.isAddDependentSkipped && !this.actionTaken)
                this.props.savePreferenceCall();
            return true;
        });
    }

    componentDidUpdate() {
        const { primaryUser, hasMychart, proxyListLoaded, myProxies } = this.props;
        if (!hasMychart || proxyListLoaded && (myProxies.length < 2 && primaryUser.isMinor)) {
            this.props.history.replace("/evisitnow");
        }
    }

    componentWillUnmount() {
        try {
            this.savePreference();
        } catch (err) {
            console.log(err);
        }
    }

    shouldLoadEVistPage() {
        //this.setState({ loadEVisit: true });

    }

    onUserSelected = userSelected => {
        this.ourCallback();
    };

    ourCallback() {
        //At this point, primary or proxy user has been selected, so navigate to the next stop
        //debugger;
        this.props.history.push("/evisitnow");

        //const { userSelected } = this.state;
        //const activeUserIndex = userSelected.index ? userSelected.index : 0;

        //if (this.state.activeUserIndex === activeUserIndex) {
        //    this.setState({ activeUserIndex, userSelected });
        //}
        //else {
        //    this.setState({ activeUserIndex });
        //}
    }

    onUserSwitched = (userSelected, index) => {
        //this.setState({ userSelected });
        //debugger;
        this.props.switchToMyChartUser(userSelected, index, () => {
            window.userToSwitch = userSelected;
            this.ourCallback();
        });
    }

    onSkipProxy = (isAddDependentSkipped) => {
        this.setState({ isAddDependentSkipped });
    }

    render() {
        const { failure, primaryUser, currentUser, myProxies, technicalHelpDeskNumber, zipnosis, proxyListLoaded, hasMychart, showDependentProxyForm, age, serverData, hideProxySelector } = this.props;
        const { userSelected } = this.state;
        const isProxyAvailable = myProxies && myProxies.length > 1 ? true : false;
        const eVisitmessage = "Who is this for?";
        const isAdult = age && age > 17 ? true : false;

        let heading = 'eVisit';
        if (currentUser && typeof primaryUser.externalId !== 'undefined' &&
            currentUser.externalId !== primaryUser.externalId && currentUser.displayName) {
            heading += ' (' + getFirstName(currentUser.displayName) + ')';
        }

        let body = null;
        if (!hasMychart || (!failure && !proxyListLoaded)) {
            body = (<div className="row">
                <div className="col-12 maxWidth-content">
                    <Spinner />
                </div>
            </div>);
        }
        else if (failure || (zipnosis && zipnosis.error)) {
            body =
                (<div id="evisit-action" className="row">
                    <div className="col-12 maxWidth-content">
                        <h1 className="page-heading">{heading}</h1>
                        <SectionLoadingError message={this.unexpectedErrorMessage} />
                    </div>
                </div>);
        }
        else if (!userSelected) {
            body = (<><div className="row">
                {isProxyAvailable &&
                    <SelectPatient message={eVisitmessage}
                        myProxies={myProxies} currentUser={currentUser}
                        switchToMyChartUser={this.onUserSwitched}
                        hasMychart={hasMychart}
                        isAdult={isAdult}
                        fromEvisit activityCode="MBHWeb.UI.EVisit.ProxySelector.AddDependent.Clicked"
                        className="col-12 maxWidth-content"
                        serverData={serverData}
                        onUserSelected={this.onUserSelected}
                    />
                }
            </div>
                {!isProxyAvailable ? showDependentProxyForm && hasMychart && isAdult
                    ? <NoProxy message={eVisitmessage} myProxies={myProxies} currentUser={currentUser} switchToMyChartUser={this.onUserSwitched}
                        fromEvisit stepHeading={"Did you know?"} titleInfo={"You can do an eVisit for a dependent ages 2-17."} iconRightClass={"svg-dependent"} serverData={serverData}
                        savePreferenceCall={this.props.savePreferenceCall} onSkipProxy={this.onSkipProxy}
                        onActionTaken={(actionTaken) => { this.actionTaken = actionTaken; }} onUserSelected={this.onUserSelected}
                        activityCode="MBHWeb.UI.EVisit.NoProxy.AddDependent.Clicked"
                    />
                    : <Redirect to="/evisitnow" /> : ""}
            </>
            );
        }
        if (hideProxySelector)
            body = <Redirect to="/evisitnow" />;

        return (
            <div id="evisit-landing" className="container-fluid body-content">
                {body}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    return {
        failure: state.memberships.proxyListFailure,
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        currentUser: d.hydrateProxyUser(state.domain.cu),
        serverData: state.session.serverData,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        myProxies: pl,
        zipnosis: state.header.zipnosis,
        history: state.session.history,
        hasMychart: !state.common.epicEHRDown && state.domain.hm,
        proxyListLoaded: state.memberships.proxyListLoaded,
        showDependentProxyForm: state.session.showDependentProxyForm,
        age: state.domain.age
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index, callback) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index, callback });
        },
        savePreferenceCall: () => {
            dispatch({
                type: types.UPDATE_ADD_DEPENDENT_PROXY_PREFERENCE
            });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EVisit_ProxySelector);